<script>
  import { setContext } from 'svelte';

  import context from './banner.context';
  import store from './banner.store';
  import Banner from './banner.svelte';
  import positions from './positions';

  setContext(context, store);
</script>

<slot />

<div class="banners">
  {#each positions as position}
    <div class={`banners-position-${position}`}>
      {#each $store as banner (banner.id)}
        {#if banner.position === position}
          <Banner {banner} />
        {/if}
      {/each}
    </div>
  {/each}
</div>

<style lang="scss" src="./banners.scss"></style>
